import React, { useState } from "react"

import { css } from "@emotion/css"
import { useWindowResize, useMediaQuery } from "beautiful-react-hooks"

interface Props {
  children: React.ReactNode
}

export function PhoneWrapper({ children }: Props) {
  const isSmall = useMediaQuery("(max-width: 500px)")
  const [height, setHeight] = useState(window.innerHeight)

  useWindowResize(() => {
    setHeight(window.innerHeight)
  })

  if (isSmall) {
    return (
      <div style={{ height }} className={outerStyle}>
        {children}
      </div>
    )
  }

  return (
    <div className={outerStyle}>
      <div className={deviceStyle}>{children}</div>
    </div>
  )
}

const outerStyle = css`
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  place-content: center;
  place-items: center;
`

const deviceStyle = css`
  position: absolute;
  display: flex;
  width: 320px;
  height: 568px;
  border: 1px solid #fafafa;
  border-radius: 10px;
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`
